<template>
    <div class="body">
        <div class="col-12 pb-5 mb-4" v-if="pageloader">
            <img src="../../assets/pageloader.svg" class="pageloader" alt="pageloader">
        </div>
        <div class="col-12 pl-0 pr-0" :class="{'individualpage' :individualPage}" v-else>
            <div class="d-flex backgroundcolor2 borderadius12 p-1 pr-3 mb-2 pointer ml-3" v-if="individualPage" @click="NavToJob">
                <img src="../../assets/JobBack.svg" alt="back">
                <span class="fontsize12 stylebold black ml-1">Back</span>
            </div>
            <div class="card">
                <div class="p-3 pt-4 d-flex">
                    <div class="pl-0 p-2 text-center">
                        <img v-if="jobApplicantDetails.profilePictureLink" :src="jobApplicantDetails.profilePictureLink" @error="jobApplicantDetails.profilePictureLink = null" width="70px" class="img-fluid border borderradiushalf rounded-circle loadingBgImg" alt="profilepic">
                        <img v-else src="../../assets/Profile_placehlder.svg" width="70px" class="img-fluid border border-dark borderradiushalf rounded-circle" alt="profilepic">
                    </div>
                    <div class="col-10">
                        <div class="d-flex justify-content-between">
                            <div class="d-flex flex-column">
                                <span class="fontsize24 proximanova my-auto">{{jobApplicantDetails.firstName}} {{jobApplicantDetails.lastName}}
                                    <img src="../../assets/verify_blue.svg" class="my-auto" alt="verify" width="20px" title="Verified" v-if="jobApplicantDetails.verifiedProfile == 'SUCCESS'"> 
                                </span>
                                <span class="fontsize16 black60 proximanova">{{jobApplicantDetails.designation.roleName}} | {{jobApplicantDetails.companyDetails.companyName}} | {{jobApplicantDetails.country.countryName}}</span>
                            </div>
                            <div class="d-lg-flex d-md-flex">
                                <div class="backgroundcolor6 borderadius12 bordergreen pl-2 pr-2 stylebold green badgebtn bdgebtn1 mr-2 pointer" v-if="jobApplicantCurrentStatus">
                                    <span class="fontsize12 proximanova my-auto" >{{jobApplicantCurrentStatus.jobStatus}}</span>
                                </div>
                                <!-- <div class="backgroundcolor2 borderadius12 pl-2 pr-2 badgebtn pointer mr-2 mt-2 mt-lg-0 mt-md-0" v-if="jobApplicantCurrentStatus && jobApplicantCurrentStatus.jobStatus !== 'Hired'"> -->
                                    <div class="backgroundcolor2 borderadius12 pl-2 pr-2 badgebtn pointer mr-2 mt-2 mt-lg-0 mt-md-0">
                                    <span class="fontsizemd black proximanova" v-popover:candidatePopover>Move to</span>
                                    <popover name="candidatePopover" class="postvideomenu" id="videoProfile">
                                        <div class="">
                                            <div class="p-1 mouseoveraction"  >
                                                <span class="pt-1 pl-2 d-flex flex-column">
                                                    <div class="fontsize12 black80" :disable="jobApplicantCurrentStatus && jobApplicantCurrentStatus.seq > 0"
                                                    @click="updateJobApplicantStatus('Disqualified', jobApplicantCurrentStatus)"
                                                    :class="{'blue stylebold' :jobApplicantCurrentStatus && jobApplicantCurrentStatus.jobStatus === 'Disqualified'}">Rejected</div>
                                                </span>
                                            </div>
                                            <div class="horizontalline"></div>
                                            <div class="p-1 mouseoveraction"  >
                                                <span class="pt-1 pl-1 d-flex flex-column ml-1">
                                                    <div class="fontsize12 black80" :disable="jobApplicantCurrentStatus && jobApplicantCurrentStatus.seq > 0"
                                                    @click="updateJobApplicantStatus('Review', jobApplicantCurrentStatus)"
                                                    :class="{'blue stylebold' :jobApplicantCurrentStatus && jobApplicantCurrentStatus.jobStatus  === 'Review'}">Review</div> 
                                                </span>
                                            </div>
                                            <div class="horizontalline"></div>
                                            <div class="p-1 mouseoveraction" >
                                                <span class="pt-1 pl-1 d-flex flex-column ml-1">
                                                    <div class="fontsize12 black80" :disable="jobApplicantCurrentStatus && jobApplicantCurrentStatus.seq > 1"
                                                    @click="updateJobApplicantStatus('Assessment', jobApplicantCurrentStatus)" 
                                                    :class="{'blue stylebold' :jobApplicantCurrentStatus && jobApplicantCurrentStatus.jobStatus  === 'Assessment'}">Assessment</div> 
                                                </span>
                                            </div>
                                            <div class="horizontalline"></div>
                                            <div class="p-1 mouseoveraction" >
                                                <span class="pt-1 pl-1 d-flex flex-column ml-1">
                                                    <div class="fontsize12 black80" :disable="jobApplicantCurrentStatus && jobApplicantCurrentStatus.seq > 2"
                                                    @click="updateJobApplicantStatus('Shortlisted', jobApplicantCurrentStatus)" 
                                                    :class="{'blue stylebold' :jobApplicantCurrentStatus && jobApplicantCurrentStatus.jobStatus  === 'Shortlisted'}">Shortlisted</div> 
                                                </span>
                                            </div>
                                            <div class="horizontalline"></div>
                                            <div class="p-1 mouseoveraction"  >
                                                <span class="pt-1 pl-1 d-flex flex-column ml-1">
                                                    <div class="fontsize12 black80" :disable="jobApplicantCurrentStatus && jobApplicantCurrentStatus.seq > 3"
                                                    @click="updateJobApplicantStatus('Interview', jobApplicantCurrentStatus)"
                                                    :class="{'blue stylebold' :jobApplicantCurrentStatus && jobApplicantCurrentStatus.jobStatus=== 'Interview'}">Interview</div> 
                                                </span>
                                            </div>
                                            <div class="horizontalline"></div>
                                            <div class="p-1 mouseoveraction"  >
                                                <span class="pt-1 pl-1 d-flex flex-column ml-1">
                                                    <div class="fontsize12 black80" :disable="jobApplicantCurrentStatus && jobApplicantCurrentStatus.seq > 4"
                                                    @click="updateJobApplicantStatus('Selected', jobApplicantCurrentStatus)"
                                                    :class="{'blue stylebold' :jobApplicantCurrentStatus && jobApplicantCurrentStatus.jobStatus=== 'Selected'}">Selected</div> 
                                                </span>
                                            </div>
                                            <div class="horizontalline"></div>
                                            <div class="p-1 mouseoveraction"  > 
                                                <span class="pt-1 pl-1 d-flex flex-column ml-1">
                                                    <div class="fontsize12 black80" :disable="jobApplicantCurrentStatus && jobApplicantCurrentStatus.seq > 5"
                                                    @click="updateJobApplicantStatus('Hired', jobApplicantCurrentStatus)"
                                                    :class="{'blue stylebold' :jobApplicantCurrentStatus && jobApplicantCurrentStatus.jobStatus === 'Hired'}">Hired</div> 
                                                </span>
                                            </div>
                                        </div>
                                    </popover>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="mt-3">
                            <span class="fontsize16 black proximanova">{{jobApplicantDetails.aboutYou}}</span>
                        </div> -->
                        <div v-if="totalDescription" class="d-flex flex-nowrap mt-3 pr-1">
                            <div class="fontsize14 proximanova black60">
                            {{totalDescription}}
                            <!-- <span @click="readmoreDescription()" v-if="totalDescription.length > 124"><span v-if="!readmoreclicked" class="proximanova fontsize14 blue pointer">...readmore</span></span>
                            <span class="proximanova fontsize14 blue pointer" v-if="readmoreclicked" @click="readlessDescription()">...readless</span> -->
                            </div>
                        </div>
                        <div class="d-flex flex-wrap badgesection mt-2" >
                            <span  v-for="(badge, index) in userBadgeList" :key="index">
                                <span :class="'colour'+badge.badgeList.badgeIn.charAt(0) + ' border'+badge.badgeList.badgeIn.charAt(0)" class="borderblack60 text-capitalize pl-2 pr-2 pointer lineheight p-1 mt-2 mr-2 borderradius20 fontsize12 proximanova-semibold" v-if="index < 6">
                                    {{badge.badgeList.badgeIn}}
                                </span>
                                <span :class="'colour'+badge.badgeList.badgeIn.charAt(0) + ' border'+badge.badgeList.badgeIn.charAt(0)" class="borderblack60 text-capitalize pl-2 pr-2 pointer lineheight p-1 mt-2 mr-2 borderradius20 fontsize12 proximanova-semibold" v-if="index >= 6 && viewMoreBadges">
                                    {{badge.badgeList.badgeIn}}
                                </span>
                                <span class="borderblack60 pl-2 pr-2 pointer backgroundcolor5 lineheight p-1 mt-2 mr-2 borderradius20 fontsize12 proximanova-semibold" v-if="index > 5 && index == 6 && !viewMoreBadges" @click="ViewMoreBadgesList">
                                    + {{userBadgeList.length - 6}}
                                </span>
                                <span class="borderblack60 pl-2 pr-2 pointer backgroundcolor5 lineheight p-1 mt-2 mr-2 borderradius20 fontsize12 proximanova-semibold" v-if="index > 5 && index == (userBadgeList.length-1) && viewMoreBadges" @click="ViewMoreBadgesList">
                                    View Less
                                </span>
                            </span>
                        </div>
                        <div class="d-flex flex-wrap badgesection mt-2">
                            <span class="d-flex flex-wrap" v-for="(link, index1) in userLinksList" :key="index1">
                                <span class="d-none d-md-block pointer p-1">
                                    <a :href="link.userLinks.url" target="_blank" rel="noopener noreferrer">
                                    <img :src="require('../../assets/userlinks_'+link.linkName+'.svg')" width="30px" class="pl-1 pr-1" alt="link img">
                                    </a>
                                </span>
                                <span class="d-block d-md-none pointer p-1" v-if="index1 < 4">
                                    <a :href="link.userLinks.url" target="_blank" rel="noopener noreferrer">
                                    <img :src="require('../../assets/userlinks_'+link.linkName+'.svg')" width="30px" class="pl-1 pr-1" alt="link img">
                                    </a>
                                </span>
                                <span class="d-block d-md-none pointer p-1" v-if="index1 >= 4 && viewMoreLinks">
                                    <a :href="link.userLinks.url" target="_blank" rel="noopener noreferrer">
                                    <img :src="require('../../assets/userlinks_'+link.linkName+'.svg')" width="30px" class="pl-1 pr-1" alt="link img">
                                    </a>
                                </span>
                                <span class="d-block d-md-none borderblack60 pl-2 pr-2 pointer backgroundcolor5 lineheight mt-1 mr-2 borderradius20 fontsize12 proximanova-semibold" v-if="index1 > 3 && index1 == 4 && !viewMoreLinks" @click="ViewMoreLinksList">
                                    + {{userLinksList.length - 4}}
                                </span>
                                <span class="d-block d-md-none borderblack60 pl-2 pr-2 pointer backgroundcolor5 lineheight mt-1 mr-2 borderradius20 fontsize12 proximanova-semibold" v-if="index1 > 3 && index1 == (userLinksList.length-1) && viewMoreLinks" @click="ViewMoreLinksList">
                                    View Less
                                </span>
                            </span>
                        </div>
                        <span class="proximanova-semibold black fontsize14 ml-1" v-if="openToWorkList.length>0">I'm open to work as</span>
                        <div class="d-flex flex-wrap badgesection mt-1 mb-3" >
                            <span  v-for="(open, index) in openToWorkList" :key="index">
                                <span :class="'colour'+open.indexDetailName.charAt(0) + ' border'+open.indexDetailName.charAt(0)" class="borderblack60 text-capitalize pl-2 pr-2 lineheight p-1 mt-2 mr-2 borderradius20 fontsize14 proximanova">
                                {{open.indexDetailName}}
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="bordertop"></div>
                <div class="backgroundcolor1 p-2 pb-3 pl-lg-4 pr-lg-4">
                    <div class="d-lg-flex d-flex flex-wrap">
                        <div class="d-flex col-lg-4 col-md-4 mt-2" v-if="jobApplicantDetails.email">
                            <div><img src="../../assets/candidate_email.svg" class="img-fluid" alt="email"></div>
                            <div class="d-flex flex-column ml-2 mt-1" >
                                <span class="fontsizemd black60 proximanova stylebold">Email ID</span>
                                <span class="fontsize14 black proximanova stylebold">{{jobApplicantDetails.email}}</span>
                            </div>
                        </div>
                        <div class="d-flex col-lg-4 col-md-4 mt-2" v-if="jobApplicantDetails.primaryPhoneNumber">
                            <div><img src="../../assets/candidate_phone.svg" class="img-fluid" alt="phone"></div>
                            <div class="d-flex flex-column ml-2 mt-1">
                                <span class="fontsizemd black60 proximanova stylebold">Phone - Primary</span>
                                <span class="fontsize14 black proximanova stylebold">{{jobApplicantDetails.primaryPhoneNumber}}</span>
                            </div>
                        </div>
                        <div class="d-flex col-lg-4 col-md-4  mt-2" v-if="jobApplicantDetails.alternatePhoneNumber">
                            <div><img src="../../assets/candidate_phone.svg" class="img-fluid" alt="phone"></div>
                            <div class="d-flex flex-column ml-2 mt-1">
                                <span class="fontsizemd black60 proximanova stylebold">Phone - Alternate</span>
                                <span class="fontsize14 black proximanova stylebold">{{jobApplicantDetails.alternatePhoneNumber}}</span>
                            </div>
                        </div>
                        <div class="d-flex col mt-2" v-if="jobApplicantDetails.websiteUrl">
                            <div><img src="../../assets/candidate_website.svg" class="img-fluid" alt="website"></div>
                            <div class="d-flex flex-column ml-2 mt-1">
                                <span class="fontsizemd black60 proximanova stylebold">Website/Social Media</span>
                                <a class="fontsize14 black proximanova stylebold" :href="jobApplicantDetails.websiteUrl" target="_blank">{{jobApplicantDetails.websiteUrl}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="horizontalmenu">
                <nav class="nav">
                    <div class="col-12 card-header mt-3 mt-lg-4 mb-3">
                        <ul class="col-12 p-1 d-flex flex-nowrap  nav nav-tabs  text-center">
                            <li class="pr-0 pl-0 nav-item p-1 pl-lg-3 pl-3 pr-3 pb-2 pr-lg-4">
                                <div class="text-left pointer" @click="toggleActiveuserTab('alldetails')">
                                    <span class="fontsize12 black60 stylebold proximanova text-nowrap" :class="{ 'list-text-color borderbottomblue' :activeuserTab==='alldetails'}">All Details</span>
                                </div>
                            </li>
                            <div class="verticaline mt-1"></div>
                            <li class="pr-0 pl-0 nav-item pointer p-1 pb-2 pl-3 pr-3 pl-lg-4 pr-lg-4">
                                <div class="text-left" @click="toggleActiveuserTab('videoresume')">
                                    <span class="fontsize12 black60 stylebold proximanova text-nowrap" :class="{ 'list-text-color borderbottomblue' :activeuserTab==='videoresume'}">Video Resume</span>
                                </div>
                            </li> 
                            <div class="verticaline mt-1"></div>
                            <li class="pr-0 pl-0 nav-item pointer p-1 pb-2 pl-3 pr-3 pl-lg-4 pr-lg-4">
                                <div class="text-left" @click="toggleActiveuserTab('videoprofile')">
                                    <span class="fontsize12 black60 stylebold proximanova text-nowrap" :class="{ 'list-text-color borderbottomblue' :activeuserTab==='videoprofile'}">Video Profile</span>
                                </div>
                            </li>
                            <div class="verticaline mt-1"></div>
                            <li class="pr-0 pl-0 nav-item pointer p-1 pb-2 pl-3 pr-3 pl-lg-4 pr-lg-4">
                                <div class="text-left" @click="toggleActiveuserTab('screeningQuestions')">
                                    <span class="fontsize12 black60 stylebold proximanova text-nowrap" :class="{ 'list-text-color borderbottomblue' :activeuserTab==='screeningQuestions'}">Screening Questions</span>
                                </div>
                            </li> 
                            <div class="verticaline mt-1"></div>
                            <li class="pr-0 pl-0 nav-item pointer p-1 pb-2 pl-3 pr-3 pl-lg-4 pr-lg-4">
                                <div class="text-left" @click="toggleActiveuserTab('textresume')">
                                    <span class="fontsize12 black60 stylebold proximanova text-nowrap" :class="{ 'list-text-color borderbottomblue' :activeuserTab==='textresume'}">Text Resume</span>
                                </div>
                            </li>                        
                        </ul>
                    </div>
                </nav>
            </div>
            <all-details v-if="allDetailsTab" :jobApplicantDetails="jobApplicantDetails"></all-details>
            <video-resume v-if="videoResumeTab" :jobApplicantDetails="jobApplicantDetails"></video-resume>
            <videoprofile v-if="videoProfileTab" :jobApplicantDetails="jobApplicantDetails"></videoprofile>
            <screening-questions v-if="screeningQuestionsTab" :jobApplicantDetails="jobApplicantDetails"></screening-questions>
            <text-resume v-if="textResumeTab" :jobApplicantDetails="jobApplicantDetails"></text-resume>
        </div>
        <APIErrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIErrorModal>
    </div>
</template>
<script>
import { bus } from "@/main.js";
import httpuserprofile from "@/js/http-userprofile.js";
import httppostajob from "@/js/http-postjob.js"
import allDetails from './candidate/AllDetails.vue'
import videoResume from './candidate/VideoResume.vue'
import videoprofile from './candidate/VideoProfile.vue'
import screeningQuestions from './candidate/ScreeningQuestions.vue'
import textResume from './candidate/TextResume.vue'
import router from '../../router.js'
import APIErrorModal from '../../components/APIerrorpopup.vue'
import sessionUtils from "@/js/session-util.js";
export default {
    components : {
        allDetails,
        videoResume,
        videoprofile,
        screeningQuestions,
        textResume,
        APIErrorModal
    },
    data(){
        return{
            displayAPIerrorModal : false,
            pageloader : true,
            jobId : null,
            companyProfileId : null,
            companyUserEmail : null,
            jobApplicantId : null,
            jobApplicantProfileId : null,
            jobApplicantCurrentStatus : null,
            updateApplicationStatus : false,
            jobApplicantDetails : null,
            individualPage : false,
            activeuserTab : 'alldetails',
            allDetailsTab : true,
            videoResumeTab : false,
            videoProfileTab : false,
            textResumeTab : false,
            screeningQuestionsTab : false,
            //list
            employmentTypeList : [],
            typeOfDegreeList : [],
            //user data
            aboutyou : '',
            totalDescription : '',
            aboutYou1 : '',
            aboutYou2 : '',
            readmoreclicked : false,
             //badges & links
            userBadgeList : [],
            viewMoreBadges : false,
            userLinksList : [],
            viewMoreLinks : false,
            // open to work section
            openToWorkList : [],
        }
    },
    mounted() {
        this.jobId = sessionUtils.getSelectedJobId();
        this.companyProfileId = sessionUtils.getCompanyProfileId();
        this.companyUserEmail = sessionUtils.getCompanyEmail();
        this.jobApplicantId = this.$session.get("selectedApplicantId");
        this.getEmploymentType()
        this.getTypeofDegreeList()
        if(this.individualPage){
            this.resetData()
            this.getselectedApplicantData()
        }
        bus.$on("applicantSelection", data => {
          console.log("data in videoviews : ", data)
          this.activeuserTab = 'alldetails';
          this.toggleActiveuserTab(this.activeuserTab);
          this.jobApplicantId = data.userId;
          this.jobApplicantCurrentStatus = data.userCurrentStatus;
          this.resetData()
          this.getselectedApplicantData()
        });
        bus.$on("openUserDetailsTab", data => {
            this.toggleActiveuserTab(data)
        })
        bus.$on("getCandidatesByStatus", data => {
            this.pageloader = true
        })
    },
    methods : {
        resetData() {
            this.jobApplicantDetails = null;
            this.totalDescription = false;
            this.userBadgeList = [];
            this.userLinksList = [];
            this.openToWorkList = [];
            this.viewMoreBadges = false;
            this.viewMoreLinks = false;
        },
        closeAPIerrorModal(){
            this.displayAPIerrorModal = false;
        },
        //this will invoke after component created
        getEmploymentType : function() {
            httpuserprofile.get("searchController/getIndexDetailsList", {
                params: { indexCode: 2 }
            }).then(response => {
                this.employmentTypeList = response.data;
            });
        },
        getTypeofDegreeList : function(){
            httpuserprofile.get("searchController/getIndexDetailsList", {
                params: { indexCode: 4 }
            }).then(response => {
                this.typeOfDegreeList = response.data;
            });
        },
        readmoreDescription : function(){
            this.totalDescription = this.totalDescription.concat(this.aboutYou2)
            this.readmoreclicked = true
        },
        readlessDescription : function() {
            this.readmoreclicked = false;
            this.totalDescription = this.totalDescription.substr(0, 125)
        },
        //this will invoke after click on job applicant status change
        updateJobApplicantStatus(status, jobApplicantCurrentStatus){
            if(!this.updateApplicationStatus){
            console.log(status)
            // var jobFd = new FormData()
            let jobobj = {
                applicationId : null,
                jobStatus : status,
                seq : null,
                comments : null,
                creationUserI : this.companyUserEmail
            }
            this.updateApplicationStatus = true;
            // if(jobApplicantCurrentStatus){
            //     jobobj.applicationId = jobApplicantCurrentStatus.applicationId
            // }
            let applicationIds = [];
            applicationIds.push(jobApplicantCurrentStatus.applicationId)
            // var pblob = new Blob([JSON.stringify(obj)], { type: "application/json" })
            // var jobblob = new Blob([JSON.stringify(this.jobId)], { type: "application/json" })
            // var profblob = new Blob([JSON.stringify(this.jobApplicantDetails.profileId)], { type: "application/json" })
            // jobFd.append("statusData", pblob)
            // jobFd.append("jobId", jobblob)
            // jobFd.append("userProfileId", profblob)
            // httpuserprofile.get('/userprofile/updateJobApplicantStatus', obj)
            // .then((response) => {
            //     console.log(response)
            // }).catch((e) => {
            //     console.log(e)
            // })
            httppostajob.post('/postjob/updateJobApplicantStatus?jobId='+this.jobId+'&applicationIdList='+applicationIds, jobobj, {
            // httpuserprofile.post('/userprofile/updateJobApplicantStatus', jobFd, {
                // headers: {
                //     "Content-Type": "multipart/form-data",
                //     "Accept" : "*/*"
                // }
            }).then((response) => {
                console.log("update status : ", response)
                let obj = {
                    status : true
                }
                this.updateApplicationStatus = false;
                this.pageloader = true;
                bus.$emit("updateJobApplicantsInformation", obj)
            }).catch((e) => {
                console.log(e)
                this.updateApplicationStatus = false;
                this.displayAPIerrorModal = true;
            })
            }
        },
        //this will invoke aftre component mounted and updated
        getselectedApplicantData(){
            this.pageloader = true;
            httpuserprofile.get('/userprofile/userbyid/'+this.jobApplicantId)
            .then((response) => {
                this.pageloader = false;
                console.log(response)
                // this.aboutYou = response.data.aboutYou;
                this.totalDescription = response.data.aboutYou;
                this.jobApplicantProfileId = response.data.profileId;
                // if(aboutyou) {
                //     // this.aboutYou1 = aboutyou.substr(0, 125)
                //     // this.totalDescription = this.aboutYou1
                //     // this.aboutYou1 = aboutyou.substr(0, 125)
                //     // this.aboutYou2 = aboutyou.substr(125)
                //     this.totalDescription = aboutyou;
                // }
                //experience
                var finalexperienceList = [];
                if (response.data.workExperience.length > 0) {
                    let experienceList = response.data.workExperience
                    for(var i =0; i < experienceList.length; i++){
                        for(var j = 0; j < this.employmentTypeList.length; j++){
                            if(this.employmentTypeList[j].id == experienceList[i].employeementTypeId) {
                            experienceList[i].employeementTypeString = this.employmentTypeList[j].indexDetailName;
                            }
                        }
                        let descript =  experienceList[i].description;
                        experienceList[i].description1 = descript.substr(0,196)
                        experienceList[i].description2 = descript.substr(196)
                        finalexperienceList.push(experienceList[i])
                    }
                }
                var finaleducationList = [];
                //education
                if(response.data.userEducation.length > 0){
                    let education = response.data.userEducation
                    for(var k =0; k < education.length; k++){
                        for(var l=0; l < this.typeOfDegreeList.length; l++){
                            if(this.typeOfDegreeList[l].id == education[k].typeOfDegreeId) {
                            education[k].typeOfDegreeString = this.typeOfDegreeList[l].indexDetailName
                            }
                        }
                        finaleducationList.push(education[k])
                    }
                }
                response.data.workExperience = finalexperienceList;
                response.data.userEducation = finaleducationList;
                this.jobApplicantDetails = response.data;
                this.getAnsweredScreeningQuestions(response.data.profileId)
                this.getUserPdfData(response.data.profileId)
                if(this.jobApplicantProfileId) {
                    this.fetchUserBadgeList()
                    this.fetchUserLinksList()
                    this.fetchOpenToWorkInformation()
                }
            }).catch((e) => {
                this.pageloader = false;
                console.log(e)
            })
        },
        fetchUserBadgeList : function() {
            this.userBadgeList = []
            httpuserprofile.get("/userprofile/getUserBadges?profileId="+this.jobApplicantProfileId)
            .then((response) => {
                console.log("saved user badge list : ", response)
                if(response.data && response.data.length > 0) {
                this.userBadgeList = response.data
                }
                console.log("userbadgelist : ", this.userBadgeList)
            }).catch((e) => {
                console.log(e)
            })
        },
        fetchUserLinksList : function() {
            this.userLinksList = [];
            httpuserprofile.get("/userprofile/getUserLinksList?userProfileId="+this.jobApplicantProfileId)
            .then((response) => {
                console.log("saved user badge list : ", response)
                if(response.data && response.data.length > 0) {
                this.userLinksList = response.data
                }
                console.log("userbadgelist : ", this.userLinksList)
            }).catch((e) => {
                console.log(e)
            })
        },
        fetchOpenToWorkInformation : function() {
            httpuserprofile.get("/userprofile/getJobChangeTypeByProfileId?profileId="+this.jobApplicantProfileId)
            .then((response) => {
                console.log("saved open to work list : ", response)
                if(response.data && response.data.length > 0) {
                this.openToWorkList = response.data
                }else{
                this.openToWorkList = [];
                }
            }).catch((e) => {
                console.log(e)
            })
        },
        ViewMoreBadgesList : function() {
            this.viewMoreBadges = !this.viewMoreBadges;
        },
        ViewMoreLinksList : function() {
            this.viewMoreLinks = !this.viewMoreLinks;
        },
        //this will invoke after getting user details
        getAnsweredScreeningQuestions(applicantProfileId){
            httpuserprofile.get('/userprofile/getScreeningVideos?jobId='+sessionUtils.getSelectedJobId()+'&userProfileId='+applicantProfileId)
            .then((response) => {
                console.log(response)
                if(response.data && response.data.length > 0){
                response.data.forEach((qsn,index) => {
                    qsn.loadingVideo = false;
                    qsn.replayVideo = false;       
                });
                }
                this.jobApplicantDetails.screeningVideos = response.data
            }).catch((e) => {
                console.log(e)
            })
        },
        //this will invoke after getting user details
        getUserPdfData(applicantProfileId){
            httpuserprofile.get('/userprofile/generatePdf/'+applicantProfileId+'/1')
            .then((response) => {
                console.log(response)
                // let fileURL = response.data.url;
                this.jobApplicantDetails.pdfURL = response.data.url;
                // let fileLink = document.createElement('a');
                // //console.log(fileURL);
                // //fileLink.href = 'http://www.africau.edu/images/default/sample.pdf';
                // fileLink.href = fileURL;
                // fileLink.target = '_blank';
                // fileLink.download = response.data.fileName;
                // //document.body.appendChild(fileLink);
                // console.log(fileLink)
                // fileLink.click();
            }).catch((e)=> {
                console.log(e)
            })
        },
        NavToJob() {
            router.push({
                name : 'viewjob'
            })
        },
        toggleActiveuserTab(elementId){
            this.activeuserTab = elementId;
            if(elementId === 'alldetails'){
                this.allDetailsTab = true;
                this.videoResumeTab = false;
                this.videoProfileTab = false;
                this.screeningQuestionsTab = false;
                this.textResumeTab = false;
            }else if(elementId === 'videoresume'){
                this.allDetailsTab = false;
                this.videoResumeTab = true;
                this.videoProfileTab = false;
                this.screeningQuestionsTab = false;
                this.textResumeTab = false;
            }else if(elementId === 'videoprofile'){
                this.allDetailsTab = false;
                this.videoResumeTab = false;
                this.videoProfileTab = true;
                this.screeningQuestionsTab = false;
                this.textResumeTab = false;
            }else if(elementId === 'screeningQuestions'){
                this.allDetailsTab = false;
                this.videoResumeTab = false;
                this.videoProfileTab = false;
                this.screeningQuestionsTab = true;
                this.textResumeTab = false;
            }else if(elementId === 'textresume'){
                this.allDetailsTab = false;
                this.videoResumeTab = false;
                this.videoProfileTab = false;
                this.screeningQuestionsTab = false;
                this.textResumeTab = true;
            }
        }
    },
    created(){
        let currentRoute = this.$route.name
        if(currentRoute === 'candidate_details'){
            this.individualPage = true
        }
        window.scrollTo(0,0)
    },
    beforeDestroy(){
        bus.$off('applicantSelection')
        bus.$off('openUserDetailsTab')
        bus.$off('getCandidatesByStatus')
        bus.$off('updateJobApplicantsInformation')
    },
}
</script>
<style scoped>
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.borderradiushalf{
    padding: 2px;
}
.badgebtn{
    height: 27px;
}
.bdgebtn1{
    text-align: center;
    margin-top: -2px;
}
.loadingBgImg{
  background: transparent url('../../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.individualpage{
    margin-top: 15%;
    margin-bottom: 15%;
    padding-left: 5% !important;
    padding-right: 5% !important;
}
.backgroundcolor2{
    width: 80px;
    padding-left: 20px !important;
}
.blue{
    color: #0078FF !important;
}
.card-header {
  padding: 0px;
  margin-bottom: 0;
  border: 1px solid #d9dce1;
  opacity: 0.6;
  border-radius: 8px;
  background-color: #f0f2f5;
}
.card-header {
  border-radius: 8px !important;
  overflow-x: auto;
}
.nav-link {
  padding: 0px 0px 0px 0px;
}
.horizontalline{
    margin: 2px 0 2px 0;
}
.postvideomenu.vue-popover.dropdown-position-bottom:before{
    display: none;
}
.postvideomenu.dropdown-position-bottom {
  left: unset !important;
  top: 20px !important;
  width: 150px !important;
  padding: 5px 10px 5px 10px !important;
  transform: translate3d(-65%, 10px, 10px) !important;
}
.nav-tabs {
  border-bottom: none !important;
}
nav ul li a {
  padding: 0.5rem 0.9rem;
}
.list-text-color {
  color: #0078FF ;
  font-family: "Proxima Nova";
  font-weight: bold;
  letter-spacing: 0;
}
.border-tab {
  border-bottom-style: solid;
  border-bottom-color: #0078ff;
}
@media only screen and (max-width: 550px) {
    .individualpage{
        margin-top: 22%;
        margin-bottom: 15%;
    }
}
</style>